/**
 * LayoutSelector — sceglie il layout in base a user.ux_preference
 *
 * 'responsive'   → MainLayout (layout attuale, invariato)
 * 'mobile-first' → LayoutMobileFirst (bottom nav su mobile, sidebar su desktop)
 * 'adaptive'     → LayoutAdaptive (3 breakpoint JS-driven: mobile/tablet/desktop)
 *
 * Usato in App.tsx al posto di MainLayout nella route element.
 */
import MainLayout from '@/layouts/MainLayout'
import { LayoutMobileFirst } from './LayoutMobileFirst'
import { LayoutAdaptive } from './LayoutAdaptive'
import { useUxPreference } from '@/hooks/useUxPreference'

export function LayoutSelector() {
  const { preference } = useUxPreference()

  if (preference === 'mobile-first') return <LayoutMobileFirst />
  if (preference === 'adaptive') return <LayoutAdaptive />
  return <MainLayout />
}

export default LayoutSelector
